import { Button, DatePicker, DatePickerProps, Flex, Form, Input, Modal, Typography } from 'antd';
import dayjs from 'dayjs';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from 'utils/icon';
import NotificationService from 'core/services/notification';
import { FormProps, useForm } from 'antd/es/form/Form';
import { setContractStringLink } from '../services/agreementService';
import { assignDefaultPlan } from '../services/plansService';

type FieldType = {
	start_date: string;
};

export default function RegistryPlans() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [subscribeForm] = useForm();

	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleDateChange: DatePickerProps['onChange'] = (date) => {
		if (date) {
			subscribeForm.setFieldsValue({ start_date: date });
		}
	};

	const onConfirm: FormProps<FieldType>['onFinish'] = async (values) => {
		try {
			setIsSubmitting(true);

			const { platform_use_contract_template } = await assignDefaultPlan(dayjs(values.start_date).format('YYYY-MM-DD'));

			setContractStringLink(platform_use_contract_template);

			window.scrollTo({ top: 0 });
			setTimeout(() => {
				navigate('/register/agreement');
			}, 400);
		} catch (error: any) {
			setIsSubmitting(false);
			const errorMessage = error?.response?.data?.message || t('COMMON.SUBMIT_ERROR');
			NotificationService.error(t('COMMON.ERROR'), errorMessage);
		}
	};

	return (
		<Modal
			open={true}
			closable={false}
			className="confirmationModal"
			title={
				<Flex gap={10}>
					<Icon name="info" width={40} height={40} />
					<div>
						<h6 className="mb-0">{t('REGISTER.SUBSCRIBE_INITIATING_DATE')}</h6>
						<span className="text-light" style={{ fontSize: 14 }}>
							{t('REGISTER.SUBSCRIBE_INITIATING_DATE_DESC')}
						</span>
					</div>
				</Flex>
			}
			footer={[
				<Button size="middle" key="confirm" type="primary" htmlType="submit" form="subscribeForm" loading={isSubmitting}>
					{t('REGISTER.SUBSCRIBE')}
				</Button>,
			]}
			width={{
				sm: '90%',
				md: '70%',
				lg: '50%',
				xl: '50%',
				xxl: '40%',
			}}>
			<div className="mt-4">
				<Form form={subscribeForm} name="subscribeForm" onFinish={onConfirm}>
					<Typography.Text>{t('REGISTER.CHOOSE_INITIATE_DATE')}</Typography.Text>
					<Form.Item name="start_date" style={{ maxWidth: '100%' }} rules={[{ required: true, message: t('COMMON.FIELD_REQUIRED') }]}>
						<DatePicker
							inputReadOnly
							style={{ width: '100%' }}
							minDate={dayjs().add(3, 'day')}
							maxDate={dayjs().add(1, 'month').add(3, 'day')}
							suffixIcon={<Icon name="calendar" />}
							onChange={handleDateChange}
							placeholder={t('COMMON.SELECT_DATE')}
							allowClear={false}
						/>
					</Form.Item>
				</Form>
			</div>
			<div className="highlight blue my-4">
				<h6>{t('COMMON.NOTE')}</h6>
				<p>{t('REGISTER.SUBSCRIPTION_NOTE')}</p>
			</div>
		</Modal>
	);
}
